import { useParams } from 'react-router-dom';
import CourseContent from './CourseContent';
import CourseOverview from './CourseOverview';
import courses from '../courses.json';

const myCourses = [
  {
    id: '1',
    completedLessons: 5,
  },
  {
    id: '2',
    completedLessons: 12,
  },
];

export default function CoursePage() {
  const params = useParams();
  const course = courses.find((c) => c.id === params.id);
  const myCourse = myCourses.find((c) => c.id === params.id);
  return myCourse && course ? <CourseContent course={course} /> : <CourseOverview course={course} />;
}
